/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_sidebar_menu_connect_agent = /** @type {(inputs: {}) => string} */ () => {
	return `Conectar Agente`
};

const en_sidebar_menu_connect_agent = /** @type {(inputs: {}) => string} */ () => {
	return `Connect Agent`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const sidebar_menu_connect_agent = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sidebar_menu_connect_agent(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sidebar_menu_connect_agent", locale)
	if (locale === "es") return es_sidebar_menu_connect_agent(inputs)
	return en_sidebar_menu_connect_agent(inputs)
};
export { sidebar_menu_connect_agent as "sidebar.menu.connect_agent" }